"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goerli = void 0;
exports.goerli = {
    "addresses": {
        "ProxyAdmin": "0x6Dabe230aF156463D7Df0023cd9142BaBC777BDd",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0xc87670Fc5A7C52971493A08b362B396A67bB40F5",
        "SUMER": "0xc87670Fc5A7C52971493A08b362B396A67bB40F5",
        "CompoundLens": "0x16e6516DC3b9c2AeBbA3f7F6E4AEc511Da48dedC",
        "FeedPriceOracle": "0x8CEe0D74EBa51a5fC340b5D8285E399E3985eea2",
        "AccountLiquidity": "0x59c7a034F3444da72Fd14cF794857b9A64b65aBf",
        "CompLogic": "0x89233DD4a338B4fB74CBC7110204a1dB30D69066",
        "Comptroller": "0x950B2AeA74403f841F98961e407a6D7380d9cCdb",
        "sdrMTR": "",
        "MTR": "0x0000000000000000000000000000000000000000",
        "sdrUSDC": "",
        "USDC": "0x2b27f5f7f2867ad9d2b7065f81e985c1bd1b7274",
        "sdrUSDT": "",
        "USDT": "0x2398633bee182cad2d0388b41735fd9fb742098d",
        "sdrMTRG": "",
        "MTRG": "0x8a419ef4941355476cf04933e90bf3bbf2f73814",
        "sdrwstMTRG": "",
        "wstMTRG": "0x871497Eb8596d2cBdBE5bb23D552D35bFfbb8CF5",
        "sdrETH": "",
        "ETH": "0xe8876830e7cc85dae8ce31b0802313caf856886f",
        "sdrBTC": "",
        "BTC": "0x7EB9e0Df1C6E6f1E9d3d1EdA09fcF688FE7A710c",
        "sdrsuUSD": "",
        "suUSD": "0x0d893c092f7ae9d97c13307f2d66cfb59430b4cb",
        "sdrsuETH": "",
        "suETH": "0x21351bde0B42b4Cba5c04Fc92917b8c3254b1E88",
        "sdrsuBTC": "",
        "suBTC": "0x20B00Df0c1120D2227f87180286E63EDa30f5c4c",
        "Timelock": ""
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2b27f5f7f2867ad9d2b7065f81e985c1bd1b7274",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2398633bee182cad2d0388b41735fd9fb742098d",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrMTRG",
            "ctokenAddr": "",
            "underlySym": "MTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8a419ef4941355476cf04933e90bf3bbf2f73814",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrwstMTRG",
            "ctokenAddr": "",
            "underlySym": "wstMTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x871497Eb8596d2cBdBE5bb23D552D35bFfbb8CF5",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe8876830e7cc85dae8ce31b0802313caf856886f",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrBTC",
            "ctokenAddr": "",
            "underlySym": "BTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7EB9e0Df1C6E6f1E9d3d1EdA09fcF688FE7A710c",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x0d893c092f7ae9d97c13307f2d66cfb59430b4cb",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x21351bde0B42b4Cba5c04Fc92917b8c3254b1E88",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x20B00Df0c1120D2227f87180286E63EDa30f5c4c",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrMTR",
            "ctokenAddr": "",
            "underlySym": "MTR",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [],
    "blocksPerYear": 0
};
//# sourceMappingURL=goerli.js.map